<template>
  <div class="cont">
    <div class="title">
      <div class="title_name"></div>
    </div>

    <div class="clear" style="margin-bottom:37px">
      <div class="img_cont img_cont_one clear" style="margin-right:37px" @click="gotoDetail('PD')">
        <div class="img_one img"></div>
        <div class="img_two img"></div>
        <div class="img_three img"></div>
        <div class="img_four img"></div>
      </div>
      
      <div class="img_cont img_cont_two clear" @click="gotoDetail('SD')">
        <div class="img_one img"></div>
        <div class="img_two img"></div>
        <div class="img_three img"></div>
        <div class="img_four img"></div>
      </div>

      <div class="img_cont img_cont_three clear" style="margin-top:40px;margin-right:37px" @click="gotoDetail('HD')">
        <div class="img_one img"></div>
        <div class="img_two img"></div>
        <div class="img_three img"></div>
        <div class="img_four img"></div>
      </div>

      <div class="img_cont img_cont_four clear" style="margin-top:40px"  @click="gotoDetail('HS')">
        <div class="img_one img"></div>
        <div class="img_two img"></div>
        <div class="img_three img"></div>
        <div class="img_four img"></div>
      </div>

      <div class="img_cont img_cont_five clear" style="margin-top:40px;margin-right:37px" @click="gotoDetail('FP_FS')">
        <div class="img_one img"></div>
        <div class="img_two img"></div>
        <div class="img_three img"></div>
        <div class="img_four img"></div>
      </div>

      <div class="img_cont img_cont_six clear" style="margin-top:40px" @click="gotoDetail('twoPiece')">
        <div class="img_one img"></div>
        <div class="img_two img"></div>
        <div class="img_three img"></div>
        <div class="img_four img"></div>
      </div>

      <div class="img_cont img_cont_seven clear" style="margin-top:40px" @click="gotoDetail('FC')">
        <div class="img_one img"></div>
        <div class="img_two img"></div>
        <div class="img_three img"></div>
        <div class="img_four img"></div>
      </div>

    </div>


  </div>
</template>

<script>
export default {
  name: "ContOne",
  data() {
    return {
      fit: "contain"
    };
  },
  methods: {
    gotoDetail( id ){
      // console.log( id )
      this.$router.push('/variousproducts/brakedisc/' + id )

    }
  }
};
</script>

<style lang="stylus" scoped>
.cont {
  width: 1003px;
  background-color: #fff;
  margin: 0 auto;
  padding: 62px 73px;
  box-sizing: border-box;
  position relative
}

.clear:after { 
  display: block;
  clear: both;
  content: '';
}

.title { 
  position: absolute;
  width: 170px;
  height: 108px;
  left: 66px;
  top: -68px;
  background: url('~@/assets/image/variousproducts/brakeDisc/imgt1.png');
  background-repeat: no-repeat;
  background-size: cover;
  padding: 41px 42px 39px 42px; 
  box-sizing: border-box;
}

.title_name {
  width: 86px;
  height: 28px;
  background: url('~@/assets/image/variousproducts/brakeDisc/imgt2.png');
  background-repeat: no-repeat;
  background-size: contain;
}


.img_cont {
  width: 410px;
  height: 103px;
  float: left;
  cursor pointer
}
  .img{
    background-repeat: no-repeat;
    background-size: cover;
    float: left;
  }
.img_cont_one
  .img_one{
    width: 20px;
    height: 100px;
    background: url('~@/assets/image/variousproducts/brakeDisc/img1.png');
    margin-right:5px;
  }
  .img_two{
    width: 136px;
    height: 100px;
    background: url('~@/assets/image/variousproducts/brakeDisc/img2.png');
    margin-right:6px;
  }
  .img_three{
    width: 53px;
    height: 21px;
    background: url('~@/assets/image/variousproducts/brakeDisc/img3.png');
    margin-bottom:8px
  }
  .img_four{
    width: 241px;
    height: 70px;
    background: url('~@/assets/image/variousproducts/brakeDisc/img4.png');
  }
.img_cont_two
  .img_one{
    width: 20px;
    height: 100px;
    background: url('~@/assets/image/variousproducts/brakeDisc/img5.png');
    margin-right:5px;
  }
  .img_two{
    width: 136px;
    height: 100px;
    background: url('~@/assets/image/variousproducts/brakeDisc/img6.png');
    margin-right:6px;
  }
  .img_three{
    width: 52px;
    height: 21px;
    background: url('~@/assets/image/variousproducts/brakeDisc/img7.png');
    margin-bottom: 9px
  }
  .img_four{
    width: 241px;
    height: 52px;
    background: url('~@/assets/image/variousproducts/brakeDisc/img8.png');
  }
.img_cont_three 
  .img_one{
    width: 20px;
    height: 100px;
    background: url('~@/assets/image/variousproducts/brakeDisc/img9.png');
    margin-right:5px;
  }
  .img_two{
    width: 136px;
    height: 100px;
    background: url('~@/assets/image/variousproducts/brakeDisc/img10.png');
    margin-right:6px;
  }
  .img_three{
    width: 60px;
    height: 22px;
    background: url('~@/assets/image/variousproducts/brakeDisc/img11.png');
    margin-bottom: 9px
    background-size contain
  }
  .img_four{
    width: 238px;
    height: 52px;
    background: url('~@/assets/image/variousproducts/brakeDisc/img12.png');
  }
.img_cont_four 
  .img_one{
    width: 20px;
    height: 100px;
    background: url('~@/assets/image/variousproducts/brakeDisc/img13.png');
    margin-right:5px;
  }
  .img_two{
    width: 136px;
    height: 100px;
    background: url('~@/assets/image/variousproducts/brakeDisc/img14.png');
    margin-right:6px;
  }
  .img_three{
    width: 52px;
    height: 21px;
    background: url('~@/assets/image/variousproducts/brakeDisc/img15.png');
    margin-bottom: 9px
  }
  .img_four{
    width: 241px;
    height: 52px;
    background: url('~@/assets/image/variousproducts/brakeDisc/img16.png');
  }
.img_cont_five
  .img_one{
    width: 20px;
    height: 100px;
    background: url('~@/assets/image/variousproducts/brakeDisc/img17.png');
    margin-right:5px;
  }
  .img_two{
    width: 136px;
    height: 100px;
    background: url('~@/assets/image/variousproducts/brakeDisc/img18.png');
    margin-right:6px;
  }
  .img_three{
    width: 79px;
    height: 21px;
    background: url('~@/assets/image/variousproducts/brakeDisc/img19.png');
    margin-bottom: 9px
  }
  .img_four{
    width: 241px;
    height: 70px;
    background: url('~@/assets/image/variousproducts/brakeDisc/img20.png');
  }
.img_cont_six
  .img_one{
    width: 20px;
    height: 100px;
    background: url('~@/assets/image/variousproducts/brakeDisc/img21.png');
    margin-right:5px;
  }
  .img_two{
    width: 136px;
    height: 100px;
    background: url('~@/assets/image/variousproducts/brakeDisc/img22.png');
    background-size: contain;
    background-repeat: no-repeat;
    margin-right:6px;
  }
  .img_three{
    width: 171px;
    height: 23px;
    background: url('~@/assets/image/variousproducts/brakeDisc/img23.png');
    margin-bottom: 8px
  }
  .img_four{
    width: 221px;
    height: 70px;
    background: url('~@/assets/image/variousproducts/brakeDisc/img24.png');
  }
.img_cont_seven 
  .img_one{
    width: 20px;
    height: 100px;
    background: url('~@/assets/image/variousproducts/brakeDisc/img21.png');
    margin-right:5px;
  }
  .img_two{
    width: 136px;
    height: 100px;
    background: url('~@/assets/image/variousproducts/brakeDisc/img25.png');
    background-size: contain;
    background-repeat: no-repeat;
    margin-right:6px;
  }
  .img_three{
    width: 49px;
    height: 21px;
    background: url('~@/assets/image/variousproducts/brakeDisc/img26.png');
    margin-bottom: 8px
  }
  .img_four{
    width: 240px;
    height: 70px;
    background: url('~@/assets/image/variousproducts/brakeDisc/img27.png');
  }
  
</style>